import SideBar from "components/SideBar/SideBar";
import SideBarContainer from "components/SideBarContainer/SideBarContainer";
import Wrapper from "layout/Wrapper/Wrapper";
import React, { lazy, useState } from "react";
import styles from "styles/pages/Map1.module.scss";

export default function MapWrapper(props) {
  const { children,title } = props;

  const [Notexpand, setNotExpand] = useState(false);

  function CallBack(params) {
    return setNotExpand(params);
  }


  return (
    <>
      <div className="main_wraper">
        <Wrapper isHeader={true} headerTitle={title}>
          <div className={styles.main}>
            <div
              className={
                Notexpand
                  ? `${styles.main_wrapper_flex}`
                  : `${styles.main_wrapper_flex} ${styles.main_wrapper_flex_open}`
              }
            >
              <div className={styles.main_left}>
                <SideBar handleCallBack={CallBack} />
                {/* <SideBarContainer handleCallBack={CallBack}/> */}
              </div>
              <div className={styles.main_rgt}>
                {children}
                </div>
            </div>
          </div>
        </Wrapper>
      </div>
    </>
  );
}
